import AuthService from '@/features/auth/authService'
import DataService from '@/features/data/dataService'

function setupServices({ Events, sendBugAlert, modal, translator }) {
  const baseSetup = {
    Events,
    sendBugAlert,
    modal,
    translate: translator?.translate,
  }

  new AuthService({ ...baseSetup })
  new DataService({ ...baseSetup })

  translator?.register('auth', AuthService.translations || {})
  translator?.register('rate', DataService.translations || {})
}

export default setupServices
